<div class="bg-primary text-center">
    <h2 mat-dialog-title class="mat-mdc-dialog-title text-white">
        {{ 'SendOrder' | translate}}
    </h2>
</div>

<mat-dialog-content class="mat-mdc-dialog-content text-center">
    <mat-card class="mat-mdc-card mdc-card cardWithShadow overflow-hidden">
        <mat-card-content class="mat-mdc-card-content text-center">
            <form [formGroup]="form">
                <div class="row">
                    <div class="col-md-6">
                        <mat-form-field appearance="outline" class="w-100 m-b-10">
                            <mat-label>{{ 'Date' | translate }} </mat-label>
                            <input matInput [matDatepicker]="picker" formControlName="Date">
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>

                            @if(f['Date'].touched && f['Date'].invalid)
                            {
                            <mat-hint class="m-b-16 error-msg">
                                @if(f['Date'].errors && f['Date'].errors!['required'])
                                {
                                <div class="text-error"> {{ 'SelectDate' | translate }}</div>
                                }
                            </mat-hint>
                            }
                        </mat-form-field>
                    </div>
                    <div class="col-md-6">
                        <mat-form-field appearance="outline" class="w-100 m-b-10">
                            <mat-label>{{ 'Client' | translate }} </mat-label>
                            <mat-select name="ClientId" formControlName="ClientId">
                                <mat-option value=""> {{ 'Select' | translate }} </mat-option>
                                <mat-option [value]="client.id" *ngFor="let client of AllClients">
                                    {{client.name}}
                                </mat-option>
                            </mat-select>

                            @if(f['ClientId'].touched && f['ClientId'].invalid)
                            {
                            <mat-hint class="m-b-16 error-msg">
                                @if(f['ClientId'].errors && f['ClientId'].errors!['required'])
                                {
                                <div class="text-error"> {{ 'SelectClient' | translate }}</div>
                                }
                            </mat-hint>
                            }
                        </mat-form-field>
                    </div>
                </div>
            </form>
        </mat-card-content>
    </mat-card>
    <mat-divider></mat-divider>
</mat-dialog-content>
<mat-dialog-actions>
    <div class="col-sm-12 text-center">
        <button mat-button class="Cancelbtn" (click)="onClose()"> {{ 'Back' | translate}}</button>
        <button mat-button class="orangSavebtn" (click)="Save()"> {{ 'Save' | translate}}</button>
    </div>
</mat-dialog-actions>
